import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getAvailableBalance = () => {
  return axiosPrivate.get(`/bills/api/v1/available-balance/`);
}